import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './locale/zh'; // 中文
// import zhFan from './locale/zh-fan'; // 中文繁体
import vn from './locale/vn'; // 英文
import en from './locale/en'; // 英文
// import { getBrowserLang } from '@utils';
// console.log('1111111');

Vue.use(VueI18n);

// let handleZh = zhFan;
// if (SITE_CHANNEL === 'cnTitok') {
//   handleZh = zh;
// }

export const messages = {
  USA: en,
  TC: zh,
  VNM: vn
};

// alert('11111' + localStorage.getItem('lang'));
// console.log('66666', getBrowserLang());

export const i18n = new VueI18n({
  // locale: localStorage.getItem('lang') || getBrowserLang(),
  locale: 'TC',
  messages
});
